import { Component } from '@angular/core';

@Component({
  selector: 'app-start-achieving-section',
  templateUrl: './start-achieving-section.component.html',
  styleUrls: ['./start-achieving-section.component.css']
})
export class StartAchievingSectionComponent {

}
